import { useCallback } from 'react';

import { SkinTypeOption } from '@vestico/model';

import { GridSelect } from './GridSelect';
import { SkinTypeSelectOption } from './SkinTypeSelectOption';

export interface SkinTypeSelectProps {
  options: SkinTypeOption[];
  selectedOptionIndex?: number;
  didUpdateConfig: (index: number) => void;
  errorText: string;
  showErrorIfNeeded: boolean;
}

export const SkinTypeSelect = ({ options, selectedOptionIndex, didUpdateConfig, errorText, showErrorIfNeeded }: SkinTypeSelectProps) => {
  const onConfigUpdate = useCallback((index: number) => () => didUpdateConfig(index), [didUpdateConfig]);

  const optionsMarkup = options.map((value, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <SkinTypeSelectOption key={index} option={value} selected={index === selectedOptionIndex} didUpdateConfig={onConfigUpdate(index)} />
  ));

  return (
    <GridSelect selectedOptionIndex={selectedOptionIndex} errorText={errorText} showErrorIfNeeded={showErrorIfNeeded}>
      {optionsMarkup}
    </GridSelect>
  );
};
